import script from "./CreateVacancyHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateVacancyHeader.vue?vue&type=script&setup=true&lang=js"

import "./CreateVacancyHeader.vue?vue&type=style&index=0&id=059362f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-059362f4"]])

export default __exports__